export default "__VITE_ASSET__DCuiOMTP__"